<div class="eva-action-confirmation"
     role="group"
     aria-label="Confirm action">
  @for (option of options(); track $index) {
    <ez-card class="eva-confirmation"
             [contents]="{ icon: '', cardTitle: option, cardSubtitle: '', content: '', isSVGIcon: false, radioMode: true }"
             [selected]="selectedOption() === option"
             [attr.inert]="isLocked() && selectedOption() !== option || null"
             [attr.aria-pressed]="selectedOption() === option"
             [attr.aria-disabled]="isLocked() || null"
             (selectedChange)="$event && onOptionClick(option)" />
  }
</div>